export interface Page {
  id: number,
  title: string
  lead?: string
  sef?: string
  image?: FlareImage
  meta?: {
    type?: string,
    detail_url?: string,
    html_url?: string,
    slug?: string,
    show_in_menus?: boolean,
    seo_title?: string,
    search_description?: string
    first_published_at?: string | null,
    alias_of?: string | null,
    parent?: null | Page
  },
  content?: Array<{ id?: number, type?: string, value?: any }>
}

export interface FlareImage {
  id: number,
  title?: string,
  meta?: {
    base_url?: string
    dominant_colors?: string[]
    filename?: string
    format?: string
    height?: number
    original_name?: string
    download_url?: string
    public_id?: string
    type?: 'IMAGE' | 'DOCUMENT'
    url?: string
    width?: number
  }
}

export type FlareSize = 'width' | 'height' | 'both'
export type FlareFormat = 'png' | 'jpeg' | 'webp' | 'auto'
export type FlareCrop = 'scale' | 'fit' | 'fill' | 'pad' | 'crop' | 'face'
export type FlareGravity = 'lt' | 't' | 'rt' | 'l' | 'c' | 'r' | 'lb' | 'b' | 'rb' | 'face' | 'faces'

export interface FlareOptions {
  size?: FlareSize
  width?: String | Number
  height?: String | Number
  aspectRatio?: String | Number
  crop?: FlareCrop
  backgroundColor?: String
  gravity?: FlareGravity
  zoom?: String | Number
  format?: FlareFormat
  quality?: String | Number
  radius?: String | Number
}

export interface Validate {
  type: Array<Validations> | Validations
  message?: { [key in Validations]?: string }
}

export type Validations = 'required' | 'number' | 'phone' | 'decimal' | 'email' | 'minlength' | 'maxlength' | 'min' | 'max' | 'pattern' | 'date'

export interface Flickity {
  select: (index: number, isWrapped?: boolean, isInstant?: boolean) => void
  previous: (isWrapped?: boolean, isInstant?: boolean) => void
  next: (isWrapped?: boolean, isInstant?: boolean) => void
  selectCell: (value: number | string, isWrapped?: boolean, isInstant?: boolean) => void
  resize: () => void
  reposition: () => void
  prepend: (elements: any[]) => void
  append: (elements: any[]) => void
  insert: (elements: any[], index: number) => void
  remove: (elements: any[]) => void
  playPlayer: () => void
  stopPlayer: () => void
  pausePlayer: () => void
  unpausePlayer: () => void
  viewFullscreen: () => void
  exitFullscreen: () => void
  toggleFullscreen: () => void
  destroy: () => void
  reloadCells: () => void
  getCellElements: () => void
  selectedIndex: number
  selectedElement: any
  selectedElements: any[]
  cells: any[]
  slides: any[]
  on: (eventName: string, listener: (...params: any) => any) => any
}

export interface FlickityOptions {
  draggable?: boolean
  freeScroll?: boolean
  wrapAround?: boolean
  groupCells?: boolean | number
  autoPlay?: boolean | number
  fullscreen?: boolean
  fade?: boolean
  adaptiveHeight?: boolean
  watchCSS?: boolean
  asNavFor?: string | HTMLElement
  hash?: boolean
  dragThreshold?: number
  selectedAttraction?: number
  friction?: number
  freeScrollFriction?: number
  cellSelector?: string
  initialIndex?: number
  accessibility?: boolean
  setGallerySize?: boolean
  resize?: boolean
  cellAlign?: 'left' | 'center' | 'right'
  contain?: boolean
  percentPosition?: boolean
  rightToLeft?: boolean
  prevNextButtons?: boolean
  pageDots?: boolean
  arrowShape?: string
}

export interface DynamicFormData {
  type?: string
  properties: { [key: string]: any }
  slots?: any[]
  children?: DynamicFormData[]
  default?: any
  dynamicSlots?: any[]
}

export type Brand = 'YOUNIQUE' | 'LAUREL' | 'MARADISO' | 'VIVAL' | 'STYLE_CAMPING' | 'PLANET_CAMPING'

// backend and frontend identifiers for filters
export const FilterIdentifiersObject = {
  PROPERTY_TYPE: {
    frontendId: 'kind',
    backendId: 'accommodation_kind'
  },
  BRAND: {
    frontendId: 'brand_id',
    backendId: 'brand'
  },
  CATEGORY_RATING: {
    frontendId: 'category_rating',
    backendId: 'category_rating'
  },
  PARKING: {
    frontendId: 'parking',
    backendId: 'parking'
  },
  MEAL_PLAN: {
    frontendId: 'meal_plans',
    backendId: 'meal_plans'
  },
  HOLIDAY_TYPE: {
    frontendId: 'holiday_types',
    backendId: 'holiday_type'
  },
  REGION: {
    frontendId: 'regions',
    backendId: 'region'
  },
  OFFER_TYPE: {
    frontendId: 'offer_kinds',
    backendId: 'kind'
  },
  OFFER_GROUP: {
    frontendId: 'offer_group',
    backendId: 'offer_group'
  }
}